<template>
  <a-flex class="root">
    <div class="title">
      <p>
        {{ title }}
      </p>
    </div>
    <div class="tags_container">
      <a-flex class="tags_list">
        <tag-item v-for="item in items" :key="item.id" :class="item.type">
          {{ getFormatedLabel(item.name, item.count) }}
        </tag-item>
      </a-flex>
    </div>

    <a-divider class="divider" v-if="index < 2" />
  </a-flex>
</template>

<script setup>
  import TagItem from '@/components/tags/TagItem.vue';

  defineProps({
    index: Number,
    title: String,
    items: Array,
  });

  const getFormatedLabel = (label, count) => {
    if (count > 1) {
      return `${label} (${count})`;
    }

    return label;
  };
</script>

<style scoped lang="scss">
  @use "@/assets/styles/_colors.scss" as *;

  .root {
    flex-direction: column;
    max-width: 900px;
    padding: 20px 0;
    width: 100%;

    .title {
      color: $color-table-text-secondary;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }

    .tags_list {
      flex-wrap: wrap;
      gap: 4px;

      :deep(.tag) {
        background-color: $color-bg-primary-white;
        color: $color-text-primary;
        font-size: 12px;
        padding: 4px 10px !important;
        pointer-events: none;
        user-select: none;

        &:before {
          content: '#';
        }
      }

      .subject {
        background-color: #f4eeeb;
      }

      .technology {
        background-color: #e9f3fa;
      }

      .skill {
        background-color: #ecf2ef;
      }
    }

    .divider {
      border-color: $color-bg-secondary-grey;
      margin-top: 40px;
      margin-bottom: 0;
    }
  }
</style>
